import * as zod from 'zod';

import { DHCommand } from '@sb/integrations/implementations/dh/comon/types/DHCommand';

export const DHCGI100170Command = DHCommand.extend({
  kind: zod.literal('DHCGI100170Command'),
});

export type DHCGI100170Command = zod.infer<typeof DHCGI100170Command>;
